import { AvoidFeature, TransportModes } from './TrafficOptionsDTO';
import { TruckOptions } from './TruckOptions';
import { ValueObject } from './ValueObject';

export interface TrafficOptionsProps {
  multiplier?: number;
  mode?: TransportModes;
  truck?: TruckOptions;
  departure_at?: Date | 'now';
  avoid?: {
    features: Array<AvoidFeature>;
  };
}

export class TrafficOptions extends ValueObject<TrafficOptionsProps> {
  get multiplier(): number | undefined {
    return this.props.multiplier;
  }
  set multiplier(multiplier: number | undefined) {
    this.props.multiplier = multiplier;
  }
  get mode(): TransportModes | undefined {
    return this.props.mode;
  }
  set mode(mode: TransportModes | undefined) {
    this.props.mode = mode;
  }
  get truck(): TruckOptions | undefined {
    return this.props.truck;
  }
  set truck(truck: TruckOptions | undefined) {
    this.props.truck = truck;
  }
  get departure_at(): Date | 'now' | undefined {
    return this.props.departure_at;
  }
  set departure_at(departure_at: Date | 'now' | undefined) {
    this.props.departure_at = departure_at;
  }
  get avoid(): { features: Array<AvoidFeature> } | undefined {
    return this.props.avoid;
  }
  set avoid(avoid: { features: Array<AvoidFeature> } | undefined) {
    this.props.avoid = avoid;
  }
  constructor(props: TrafficOptionsProps) {
    super(props);
  }
  static create(props: TrafficOptionsProps): TrafficOptions {
    return new TrafficOptions(props);
  }
}
